var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "row mb-3" },
        [
          _c("search-bar", {
            staticClass: "col-md-8",
            attrs: { placeholder: "Nach Namen suchen ..." },
            model: {
              value: _vm.searchString,
              callback: function($$v) {
                _vm.searchString = $$v
              },
              expression: "searchString"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-12 col-md-4 d-md-flex justify-content-end mb-3"
            },
            [
              !_vm.isNew
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-success w-100",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.isNew = true
                        }
                      }
                    },
                    [_vm._v("Neu "), _c("i", { staticClass: "fas fa-plus" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isNew
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-danger w-100",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.isNew = false
                        }
                      }
                    },
                    [
                      _vm._v("Abbrechen "),
                      _c("i", { staticClass: "fas fa-times" })
                    ]
                  )
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { mode: "out-in", name: "slide" } },
        [
          _vm.isNew
            ? _c("buero-form", {
                staticClass: "mb-5",
                attrs: {
                  schema: _vm.schema,
                  method: "post",
                  url: "/api/merchant/regional-goods"
                },
                on: { addItem: _vm.addItem, cancel: _vm.cancel }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasNoData ? _c("no-data") : _vm._e(),
      _vm._v(" "),
      !_vm.hasNoData && _vm.isLoading ? _c("loader") : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.filteredList, function(item, index) {
        return !_vm.isLoading
          ? _c("regional-good", {
              key: item.id,
              attrs: {
                categoryOptions: _vm.categoryOptions,
                "data-index": index,
                item: item,
                locationOptions: _vm.locationOptions
              },
              on: { deleteItem: _vm.deleteItem }
            })
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }